module.exports = __webpack_public_path__ + "static/media/auditorium.876085d7.jpg";